import {useEffect, useState} from 'react';
import {DOSSIER_STATE} from 'front-onceforall-core/dist/utils/dossiers';
import documentService from '../../../services/document/DocumentService';
import {captureError} from '../../../utils/log';
import {useSubcontractorDetailsStore} from '../SubcontractorDetailsStore';
import HeaderView from './HeaderView';
import SubcontractorAddPanel from './subcontractorAddPanel';

function HeaderContainer() {
  const {state: {subcontractor: {details}, dossierCountry}} = useSubcontractorDetailsStore();
  const [areDetailsShown, setAreDetailsShown] = useState(false);
  const [dossierState, setDossierState] = useState(null);
  const [isAddSubcontractorPanelOpen, setIsAddSubcontractorPanelOpen] = useState(false);

  function fetchSubcontractorDossierState() {
    if (!details.depositor) {
      setDossierState(DOSSIER_STATE.DEPOSITOR_SERVICE_DEACTIVATED);
      return;
    }

    setDossierState(null);
    documentService.getDossierState(details.organisationId, dossierCountry)
      .then(response => setDossierState(response.dossierState))
      .catch(error => {
        captureError('Error while fetching subcontractor dossier state', error);
      });
  }

  useEffect(fetchSubcontractorDossierState, [dossierCountry]);

  return (
    <>
      <HeaderView
        dossierState={dossierState}
        areDetailsShown={areDetailsShown}
        onSwitchDetails={() => setAreDetailsShown(current => !current)}
        onReinvite={() => setIsAddSubcontractorPanelOpen(true)}
      />
      <SubcontractorAddPanel
        isOpen={isAddSubcontractorPanelOpen}
        onClose={() => setIsAddSubcontractorPanelOpen(false)}
        reinvitedOrganisation={details}
      />
    </>
  );
}

export default HeaderContainer;
